module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Db-Ha-Ia.1ac0f919.png";